import React from 'react';
import styled from 'styled-components';
import { Card, Typography } from '@material-ui/core';
import { List as ListIcon } from '@material-ui/icons';

import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import { BaseSignupCardProps } from '../../../login/Signup.interface';

const StyledContent = styled.div`
  ul {
    padding-left: 32px;
    li:not(:last-child) {
      margin-bottom: 4px;
    }
  }
`;

const SignupFeaturesCard: React.FC<BaseSignupCardProps> = props => {
  const { signup } = props;
  return (
    <Card>
      <CardTitle>
        <ListIcon />
        QMS Featuers
      </CardTitle>
      <CardContent padding='large'>
        {signup.features.length > 0 ? (
          <StyledContent>
            <Typography>Selected QMS features:</Typography>
            <ul>
              {signup.features.map((feature, index) => (
                <li key={index}>
                  <Typography>{feature}</Typography>
                </li>
              ))}
            </ul>
          </StyledContent>
        ) : (
          <Typography variant='body2' color='textSecondary'>
            No features selected.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default SignupFeaturesCard;
